/**
 * Order Details Dynamic - Fetches order and tracking data and populates the order detail page.
 * Runs only on order-detail page when email (and optionally order/tracking) are in URL.
 */
(function () {
  'use strict';

  var DEFAULT_SHOPIFY_GRAPHQL_URL = 'https://et-order-tracking.clients-suntek.com/api/shopify/graphql';
  var DEFAULT_FEDEX_TRACK_URL = 'https://et-order-tracking.clients-suntek.com/api/fedex/track';

  var SHOPIFY_ORDER_QUERY = 'query GetOrdersByCustomerEmail($email: String!) { orders(first: 10, query: $email) { edges { node { id name email createdAt currentSubtotalPriceSet { shopMoney { amount currencyCode } } currentTotalPriceSet { shopMoney { amount currencyCode } } totalTaxSet { shopMoney { amount currencyCode } } totalDiscountsSet { shopMoney { amount currencyCode } } discountApplications(first: 5) { edges { node { ... on DiscountCodeApplication { code value { ... on MoneyV2 { amount currencyCode } } } } } } shippingAddress { firstName lastName address1 address2 city province country zip phone } lineItems(first: 50) { edges { node { id title quantity originalUnitPriceSet { shopMoney { amount currencyCode } } variant { id title image { url altText } } } } } shippingLines(first: 5) { edges { node { title originalPriceSet { shopMoney { amount currencyCode } } } } } fulfillments(first: 5) { trackingInfo(first: 10) { company number url } } } } } }';

  function getUrlParams() {
    var params = {};
    var search = typeof window !== 'undefined' && window.location && window.location.search;
    if (!search) return params;
    var parts = search.slice(1).split('&');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].split('=');
      if (p.length >= 2) {
        params[decodeURIComponent(p[0])] = decodeURIComponent(p.slice(1).join('=').replace(/\+/g, ' '));
      }
    }
    return params;
  }

  function isOrderDetailPage() {
    var path = (window.location.pathname || '').toLowerCase();
    var view = (getUrlParams().view || '').toLowerCase();
    return (path.indexOf('order-detail') !== -1 || view === 'order-detail');
  }

  function getFedExStatusFromCode(code) {
    if (code === 'DL') return { status: 'Delivered', stepIndex: 5 };
    if (code === 'OD') return { status: 'Out for Delivery', stepIndex: 4 };
    if (code === 'HL' || code === 'HP') return { status: 'Ready for Pickup', stepIndex: 4 };
    if (code === 'PU') return { status: 'Shipped', stepIndex: 3 };
    if (code === 'IT' || code === 'DP' || code === 'AR' || code === 'AO') return { status: 'In Transit', stepIndex: 3 };
    if (code === 'OC' || code === 'IN') return { status: 'Order Placed', stepIndex: 1 };
    return { status: 'Packed', stepIndex: 2 };
  }

  function getProgressStepFromFedEx(fedexData) {
    var statusStr = (fedexData && fedexData.status && String(fedexData.status).toLowerCase()) || '';
    if (statusStr.indexOf('delivered') !== -1) return 5;
    if (statusStr.indexOf('ready for pickup') !== -1 || statusStr.indexOf('pickup') !== -1) return 4;
    if (statusStr.indexOf('out for delivery') !== -1) return 4;
    if (statusStr.indexOf('in transit') !== -1 || statusStr.indexOf('transit') !== -1) return 3;
    if (statusStr.indexOf('picked up') !== -1 || statusStr.indexOf('shipped') !== -1) return 3;
    var latest = getLatestStatusDetail(fedexData);
    var statusInfo = latest && latest.code ? getFedExStatusFromCode(latest.code) : getFedExStatusFromCode('');
    return statusInfo.stepIndex;
  }

  function formatAddress(addr) {
    if (!addr) return '';
    var parts = [addr.address1, addr.address2, addr.city, addr.province, addr.zip, addr.country].filter(Boolean);
    return parts.join(', ');
  }

  function formatAddressShort(addr) {
    return formatAddress(addr);
  }

  function formatAddressFull(addr) {
    if (!addr) return '';
    var line1 = [addr.address1, addr.address2].filter(Boolean).join(', ');
    var line2 = [addr.city, addr.province, addr.zip].filter(Boolean).join(', ');
    return line1 + (line1 && line2 ? '\n' : '') + line2 + (addr.country ? '\n' + addr.country : '');
  }

  function formatMoney(amount, currencyCode) {
    var n = parseFloat(amount, 10);
    if (isNaN(n)) return amount;
    var formatted = n.toFixed(2);
    return formatted + ' ' + (currencyCode || 'USD');
  }

  function formatDateForEstimated(dateStr) {
    if (!dateStr) return '';
    try {
      var d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    } catch (e) {
      return dateStr;
    }
  }

  function formatShortDateFromIso(dateStr) {
    if (!dateStr) return '';
    var match = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var m = parseInt(match[2], 10) - 1;
      var day = parseInt(match[3], 10);
      return months[m] + ' ' + day;
    }
    return formatDateForEstimated(dateStr).replace(/,?\s*\d{4}$/, '').trim() || dateStr;
  }

  function formatScanEventDate(dateStr) {
    if (!dateStr) return '';
    try {
      var match = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/);
      if (match) {
        var y = match[1];
        var m = match[2];
        var day = match[3];
        var h = parseInt(match[4], 10);
        var min = match[5];
        var ampm = h >= 12 ? 'PM' : 'AM';
        h = h % 12 || 12;
        return y + '-' + m + '-' + day + ' ' + h + ':' + min + ampm;
      }
      var d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      var y2 = d.getFullYear();
      var m2 = String(d.getMonth() + 1).padStart(2, '0');
      var day2 = String(d.getDate()).padStart(2, '0');
      var h2 = d.getHours();
      var ampm2 = h2 >= 12 ? 'PM' : 'AM';
      h2 = h2 % 12 || 12;
      var min2 = String(d.getMinutes()).padStart(2, '0');
      return y2 + '-' + m2 + '-' + day2 + ' ' + h2 + ':' + min2 + ampm2;
    } catch (e) {
      return dateStr;
    }
  }

  function getApiUrls(wrapper) {
    var shopify = (wrapper && wrapper.getAttribute && wrapper.getAttribute('data-shopify-graphql-url')) || '';
    var fedex = (wrapper && wrapper.getAttribute && wrapper.getAttribute('data-fedex-track-url')) || '';
    shopify = (shopify && shopify.trim()) ? shopify.trim() : '';
    fedex = (fedex && fedex.trim()) ? fedex.trim() : '';
    if (!shopify) shopify = DEFAULT_SHOPIFY_GRAPHQL_URL;
    if (!fedex) fedex = DEFAULT_FEDEX_TRACK_URL;
    return { shopify: shopify, fedex: fedex };
  }

  function fetchOrders(email, shopifyUrl) {
    var url = (shopifyUrl && shopifyUrl.trim()) ? shopifyUrl : DEFAULT_SHOPIFY_GRAPHQL_URL;
    var query = 'email:' + (email || '').trim();
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: SHOPIFY_ORDER_QUERY,
        variables: { email: query }
      })
    }).then(function (res) {
      if (!res.ok) {
        var statusMsg = 'Orders request failed (' + res.status + ')';
        if (res.status === 404) {
          statusMsg += ' — URL not found. Set "Shopify GraphQL API URL" in Theme customizer → Order Tracking section to your backend.';
        }
        throw new Error(statusMsg);
      }
      return res.json();
    }).then(function (json) {
      if (json && json.errors) throw new Error(json.errors[0] ? json.errors[0].message : 'GraphQL error');
      return json;
    });
  }

  function fetchFedExTracking(trackingNumber, fedexUrl) {
    if (!trackingNumber) return Promise.resolve(null);
    var url = (fedexUrl && fedexUrl.trim()) ? fedexUrl : DEFAULT_FEDEX_TRACK_URL;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ trackingNumber: trackingNumber })
    }).then(function (res) { return res.json(); }).catch(function () { return null; });
  }

  function selectOrder(ordersData, orderNumberOrTracking) {
    var edges = (ordersData && ordersData.data && ordersData.data.orders && ordersData.data.orders.edges) || [];
    if (!edges.length) return null;
    var orderNumberOrTrackingNorm = (orderNumberOrTracking || '').toString().trim().toUpperCase();
    if (!orderNumberOrTrackingNorm) return edges[0].node;
    for (var i = 0; i < edges.length; i++) {
      var node = edges[i].node;
      var name = (node.name || '').toUpperCase().replace('#', '');
      if (name && orderNumberOrTrackingNorm.indexOf(name) !== -1) return node;
      var fulfillments = node.fulfillments || [];
      for (var j = 0; j < fulfillments.length; j++) {
        var infos = fulfillments[j].trackingInfo || [];
        for (var k = 0; k < infos.length; k++) {
          if ((infos[k].number || '').toUpperCase() === orderNumberOrTrackingNorm) return node;
        }
      }
    }
    return edges[0].node;
  }

  function getFirstTrackingInfo(order) {
    var fulfillments = order.fulfillments || [];
    for (var i = 0; i < fulfillments.length; i++) {
      var infos = fulfillments[i].trackingInfo || [];
      if (infos.length) return infos[0];
    }
    return null;
  }

  function getLatestStatusDetail(fedexData) {
    try {
      var complete = (fedexData && fedexData.output && fedexData.output.completeTrackResults) || [];
      if (!complete.length) return null;
      var trackResults = complete[0].trackResults || [];
      if (!trackResults.length) return null;
      return trackResults[0].latestStatusDetail || null;
    } catch (e) {
      return null;
    }
  }

  function getScanEvents(fedexData) {
    try {
      var complete = (fedexData && fedexData.output && fedexData.output.completeTrackResults) || [];
      if (!complete.length) return [];
      var trackResults = complete[0].trackResults || [];
      if (!trackResults.length) return [];
      return trackResults[0].scanEvents || [];
    } catch (e) {
      return [];
    }
  }

  function getEstimatedDeliveryDate(fedexData, orderCreatedAt) {
    try {
      var complete = (fedexData && fedexData.output && fedexData.output.completeTrackResults) || [];
      if (complete.length && complete[0].trackResults && complete[0].trackResults[0]) {
        var tr = complete[0].trackResults[0];
        var win = (tr.standardTransitTimeWindow && tr.standardTransitTimeWindow.window) || (tr.estimatedDeliveryTimeWindow && tr.estimatedDeliveryTimeWindow.window);
        if (win && win.ends) return formatDateForEstimated(win.ends);
      }
    } catch (e) {}
    return orderCreatedAt ? formatDateForEstimated(orderCreatedAt) : '';
  }

  function getProgressDatesFromFedEx(fedexData, orderCreatedAt) {
    var scanEvents = getScanEvents(fedexData);
    var dates = { 1: '', 2: '', 3: '', 4: '', 5: '' };
    var estimatedIso = '';

    try {
      var complete = (fedexData && fedexData.output && fedexData.output.completeTrackResults) || [];
      if (complete.length && complete[0].trackResults && complete[0].trackResults[0]) {
        var tr = complete[0].trackResults[0];
        var dt = tr.dateAndTimes || [];
        for (var i = 0; i < dt.length; i++) {
          if (dt[i].type === 'ESTIMATED_DELIVERY' && dt[i].dateTime) {
            estimatedIso = dt[i].dateTime;
            break;
          }
        }
      }
    } catch (e) {}

    var ocDate = '';
    var puDate = '';
    var shippedDate = '';
    var odDate = '';
    var dlDate = '';

    for (var j = 0; j < scanEvents.length; j++) {
      var ev = scanEvents[j];
      var type = (ev.eventType || '').toUpperCase();
      var d = ev.date || '';
      if (!d) continue;
      if (type === 'OC' || type === 'IN') ocDate = d;
      else if (type === 'PU') puDate = d;
      else if (type === 'DP' || type === 'AR') shippedDate = d;
      else if (type === 'OD' && !odDate) odDate = d;
      else if (type === 'DL' && !dlDate) dlDate = d;
    }
    if (!shippedDate && puDate) shippedDate = puDate;

    dates[1] = ocDate ? formatShortDateFromIso(ocDate) : (orderCreatedAt ? formatShortDateFromIso(orderCreatedAt) : '');
    dates[2] = puDate ? formatShortDateFromIso(puDate) : (ocDate ? formatShortDateFromIso(ocDate) : '');
    dates[3] = shippedDate ? formatShortDateFromIso(shippedDate) : '';
    dates[4] = odDate ? formatShortDateFromIso(odDate) : '';
    if (dlDate) {
      dates[5] = formatShortDateFromIso(dlDate);
    } else if (estimatedIso) {
      dates[5] = 'Est. ' + formatShortDateFromIso(estimatedIso);
    }

    return dates;
  }

  function getCarrierName(order, trackingInfo) {
    return (trackingInfo && trackingInfo.company) || (order && order.shippingLines && order.shippingLines.edges && order.shippingLines.edges[0] && order.shippingLines.edges[0].node && order.shippingLines.edges[0].node.title) || 'FedEx';
  }

  function applyOrderInfo(order, fedexData, trackingInfo) {
    var wrapper = document.querySelector('.order-tracking-wrapper');
    if (!wrapper) return;

    var customerName = '';
    var shippingShort = '';
    var shippingFull = '';
    var addr = order.shippingAddress || {};
    if (addr.firstName || addr.lastName) {
      customerName = [addr.firstName, addr.lastName].filter(Boolean).join(' ');
    }
    shippingShort = formatAddressShort(addr);
    shippingFull = formatAddressFull(addr);

    var orderName = order.name ? ('Order ' + (order.name.indexOf('#') === 0 ? order.name : '#' + order.name)) : '';
    var estimatedDate = getEstimatedDeliveryDate(fedexData, order.createdAt);
    var carrierName = getCarrierName(order, trackingInfo);

    var orderNumbers = wrapper.querySelectorAll('.ot-order-number');
    for (var i = 0; i < orderNumbers.length; i++) orderNumbers[i].textContent = orderName || orderNumbers[i].textContent;

    var customerNameEls = wrapper.querySelectorAll('.ot-customer-name');
    for (var j = 0; j < customerNameEls.length; j++) {
      var html = (customerName ? '<strong>' + escapeHtml(customerName) + '</strong>' : '') + (customerName && shippingShort ? ' | ' : '') + (shippingShort || '');
      customerNameEls[j].innerHTML = html || customerNameEls[j].innerHTML;
    }

    var infoRows = wrapper.querySelectorAll('.ot-info-row');
    for (var r = 0; r < infoRows.length; r++) {
      var label = infoRows[r].querySelector('.ot-info-label');
      var value = infoRows[r].querySelector('.ot-info-value');
      if (!value) continue;
      if (label && label.textContent.indexOf('Estimated') !== -1) {
        value.textContent = estimatedDate;
      } else if (label && label.textContent.indexOf('Carrier') !== -1) {
        value.textContent = carrierName;
      }
    }

    var shippingNames = wrapper.querySelectorAll('.ot-shipping-name');
    for (var s = 0; s < shippingNames.length; s++) shippingNames[s].textContent = customerName || shippingNames[s].textContent;

    var shippingAddressTexts = wrapper.querySelectorAll('.ot-shipping-address-text');
    for (var t = 0; t < shippingAddressTexts.length; t++) shippingAddressTexts[t].textContent = shippingFull || shippingAddressTexts[t].textContent;
  }

  function escapeHtml(text) {
    if (text == null) return '';
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function applyProgressSteps(stepIndex, wrapper, progressDates) {
    if (!wrapper) wrapper = document.querySelector('.order-tracking-wrapper');
    if (!wrapper) return;

    var verticalSteps = wrapper.querySelectorAll('.ot-progress-vertical .ot-progress-step');
    var horizontalSteps = wrapper.querySelectorAll('.ot-progress-horizontal .ot-h-step');
    var i;

    for (i = 0; i < verticalSteps.length; i++) {
      verticalSteps[i].classList.toggle('inactive', i >= stepIndex);
    }
    for (i = 0; i < horizontalSteps.length; i++) {
      horizontalSteps[i].classList.toggle('inactive', i >= stepIndex);
      if (progressDates && progressDates[i + 1]) {
        var dateEl = horizontalSteps[i].querySelector('.ot-h-step-date');
        if (!dateEl) {
          dateEl = document.createElement('div');
          dateEl.className = 'ot-h-step-date' + (progressDates[i + 1].indexOf('Est.') === 0 ? ' ot-h-step-date--estimated' : '');
          var titleEl = horizontalSteps[i].querySelector('.ot-h-step-title');
          if (titleEl && titleEl.nextSibling) {
            horizontalSteps[i].insertBefore(dateEl, titleEl.nextSibling);
          } else {
            horizontalSteps[i].appendChild(dateEl);
          }
        }
        if (dateEl) {
          var txt = progressDates[i + 1];
          var calendarSvg = '<svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg" class="ot-h-step-date-icon" aria-hidden="true"><path d="M7 0.5V2.5M3 0.5V2.5M0.5 4.5H9.5M1.5 1.5H8.5C9.05229 1.5 9.5 1.94772 9.5 2.5V9.5C9.5 10.0523 9.05229 10.5 8.5 10.5H1.5C0.947715 10.5 0.5 10.0523 0.5 9.5V2.5C0.5 1.94772 0.947715 1.5 1.5 1.5Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          dateEl.innerHTML = (txt.indexOf('Est.') === 0) ? calendarSvg + txt : txt;
        }
      }
    }
  }

  function getQuantityLabel(wrapper) {
    var first = wrapper && wrapper.querySelector('.ot-product-quantity');
    if (first) {
      var text = (first.textContent || '').trim();
      var idx = text.indexOf(':');
      if (idx !== -1) return text.slice(0, idx).trim();
    }
    return 'Quantity';
  }

  function applyLineItems(order, wrapper) {
    if (!wrapper) wrapper = document.querySelector('.order-tracking-wrapper');
    if (!wrapper) return;

    var quantityLabel = getQuantityLabel(wrapper);
    var lineEdges = (order.lineItems && order.lineItems.edges) || [];
    var currencyCode = (order.currentTotalPriceSet && order.currentTotalPriceSet.shopMoney && order.currentTotalPriceSet.shopMoney.currencyCode) || 'USD';

    var itemHtml = '';
    for (var i = 0; i < lineEdges.length; i++) {
      var node = lineEdges[i].node;
      var title = node.title || '';
      var variantTitle = (node.variant && node.variant.title) || '';
      var quantity = node.quantity || 1;
      var priceSet = node.originalUnitPriceSet && node.originalUnitPriceSet.shopMoney;
      var amount = priceSet && priceSet.amount ? priceSet.amount : '0';
      var priceStr = formatMoney(amount, priceSet && priceSet.currencyCode ? priceSet.currencyCode : currencyCode);
      var imgUrl = (node.variant && node.variant.image && node.variant.image.url) || '';
      var imgAlt = (node.variant && node.variant.image && node.variant.image.altText) || title;

      itemHtml += '<div class="ot-product-item">';
      itemHtml += '<div class="ot-product-image">';
      if (imgUrl) {
        itemHtml += '<img src="' + escapeHtml(imgUrl) + '" alt="' + escapeHtml(imgAlt) + '">';
      }
      itemHtml += '</div>';
      itemHtml += '<div class="ot-product-details">';
      itemHtml += '<div class="ot-product-name">' + escapeHtml(title) + '</div>';
      itemHtml += '<div class="ot-product-variant">' + escapeHtml(variantTitle) + '</div>';
      itemHtml += '<div class="ot-product-quantity">' + escapeHtml(quantityLabel) + ': ' + quantity + '</div>';
      itemHtml += '<div class="ot-product-price mobile_only">' + escapeHtml(priceStr) + '</div>';
      itemHtml += '</div>';
      itemHtml += '<div class="ot-product-price">' + escapeHtml(priceStr) + '</div>';
      itemHtml += '</div>';
    }

    var orderSections = wrapper.querySelectorAll('.ot-section');
    var itemsCountStr = lineEdges.length + ' Item' + (lineEdges.length !== 1 ? 's' : '');
    for (var s = 0; s < orderSections.length; s++) {
      var section = orderSections[s];
      var titleEl = section.querySelector('.ot-section-title');
      var titleText = titleEl ? titleEl.textContent : '';
      if (titleText.indexOf('Order Details') !== -1) {
        var productItems = section.querySelectorAll('.ot-product-item');
        for (var p = 0; p < productItems.length; p++) productItems[p].remove();
        if (titleEl) {
          titleEl.textContent = titleText.replace(/\s*\(\s*\d+\s*Items?\s*\)/, '').trim() + ' (' + itemsCountStr + ')';
        }
        var temp = document.createElement('div');
        temp.innerHTML = itemHtml;
        while (temp.firstChild) section.appendChild(temp.firstChild);
      }
    }
  }

  function applyBilling(order, wrapper) {
    if (!wrapper) wrapper = document.querySelector('.order-tracking-wrapper');
    if (!wrapper) return;

    var lineItemsSubtotal = 0;
    var lineEdges = (order.lineItems && order.lineItems.edges) || [];
    for (var i = 0; i < lineEdges.length; i++) {
      var n = lineEdges[i].node;
      if (n && n.originalUnitPriceSet && n.originalUnitPriceSet.shopMoney)
        lineItemsSubtotal += parseFloat(n.originalUnitPriceSet.shopMoney.amount, 10) * (parseInt(n.quantity, 10) || 1);
    }
    var total = order.currentTotalPriceSet && order.currentTotalPriceSet.shopMoney;
    var subtotal = total && lineItemsSubtotal > 0
      ? { amount: String(lineItemsSubtotal), currencyCode: total.currencyCode }
      : (order.currentSubtotalPriceSet && order.currentSubtotalPriceSet.shopMoney);
    var totalTax = order.totalTaxSet && order.totalTaxSet.shopMoney;
    var shippingEdges = (order.shippingLines && order.shippingLines.edges) || [];
    var shippingMoney = shippingEdges.length && shippingEdges[0].node && shippingEdges[0].node.originalPriceSet && shippingEdges[0].node.originalPriceSet.shopMoney ? shippingEdges[0].node.originalPriceSet.shopMoney : null;
    var currencyCode = (total && total.currencyCode) || 'USD';

    var discountAmount = 0;
    var discountCode = '';
    var discountEdges = (order.discountApplications && order.discountApplications.edges) || [];
    for (var d = 0; d < discountEdges.length; d++) {
      var dNode = discountEdges[d].node;
      if (dNode && dNode.code) discountCode = dNode.code;
      if (dNode && dNode.value && dNode.value.amount) discountAmount += parseFloat(dNode.value.amount, 10) || 0;
    }
    var totalDiscounts = order.totalDiscountsSet && order.totalDiscountsSet.shopMoney && parseFloat(order.totalDiscountsSet.shopMoney.amount, 10);
    if (!discountAmount && totalDiscounts > 0) discountAmount = totalDiscounts;

    var subtotalStr = subtotal ? formatMoney(subtotal.amount, subtotal.currencyCode) : '';
    var totalStr = total ? formatMoney(total.amount, total.currencyCode) : '';
    var shippingStr = shippingMoney ? formatMoney(shippingMoney.amount, shippingMoney.currencyCode) : 'Free';
    var taxStr = totalTax && parseFloat(totalTax.amount, 10) !== 0 ? formatMoney(totalTax.amount, totalTax.currencyCode) : '—';
    var discountStr = (discountEdges.length || discountAmount > 0) && discountAmount > 0 ? '-' + formatMoney(String(discountAmount), currencyCode) : '—';

    var setBilling = function (rowType, value, labelText) {
      var rows = wrapper.querySelectorAll('.ot-billing-row[data-billing-row="' + rowType + '"]');
      for (var r = 0; r < rows.length; r++) {
        var valEl = rows[r].querySelector('.ot-billing-value');
        if (valEl) valEl.textContent = value;
        if (labelText) {
          var labelEl = rows[r].querySelector('.ot-billing-label');
          if (labelEl) labelEl.textContent = labelText;
        }
      }
    };
    setBilling('subtotal', subtotalStr);
    var discountLabel = (discountEdges.length || discountAmount > 0) ? (discountCode ? 'Discount (' + discountCode + ')' : 'Discount ') : null;
    setBilling('discount', discountStr, discountLabel);
    setBilling('shipping', shippingStr);
    setBilling('taxes', taxStr);
    setBilling('total', totalStr);
  }

  function getFriendlyEventTitle(ev) {
    var type = (ev.eventType || '').toUpperCase();
    var desc = ev.eventDescription || ev.derivedStatus || '';
    var map = { OC: 'Label created', IN: 'Label created', PU: 'We have your package', IT: 'On the way', DP: 'Departed FedEx location', AR: 'Arrived at FedEx location', OD: 'Out for delivery', HP: 'Ready for pickup', HL: 'Ready for pickup', DL: 'Delivered', HA: 'Hold at location request accepted', RR: 'Delivery option requested', AO: 'Shipment arriving on time' };
    return map[type] || desc || 'Update';
  }

  function applyJourney(scanEvents, wrapper) {
    if (!wrapper) wrapper = document.querySelector('.order-tracking-wrapper');
    if (!wrapper) return;

    var chronological = scanEvents.slice(0).reverse();

    var journeySections = wrapper.querySelectorAll('.ot-section');
    for (var s = 0; s < journeySections.length; s++) {
      var section = journeySections[s];
      var titleEl = section.querySelector('.ot-section-title');
      var titleText = titleEl ? titleEl.textContent : '';
      if (titleText.indexOf('Detailed Journey') !== -1 || titleText.indexOf('Journey') !== -1) {
        var items = section.querySelectorAll('.ot-journey-item');
        for (var i = 0; i < items.length; i++) items[i].remove();
        for (var j = 0; j < chronological.length; j++) {
          var ev = chronological[j];
          var loc = (ev.scanLocation && [ev.scanLocation.city, ev.scanLocation.stateOrProvinceCode].filter(Boolean).join(', ')) || '';
          var dateStr = formatScanEventDate(ev.date);
          var desc = getFriendlyEventTitle(ev);
          var isLatest = j === chronological.length - 1;
          var itemClass = 'ot-journey-item' + (isLatest ? ' ot-journey-item--latest' : '');
          var itemHtml = '<div class="' + itemClass + '">';
          itemHtml += '<div class="ot-journey-icon"></div>';
          itemHtml += '<div class="ot-journey-content">';
          itemHtml += '<div class="ot-journey-title">' + escapeHtml(desc) + '</div>';
          itemHtml += '<div class="ot-journey-datetime">' + escapeHtml(dateStr) + '</div>';
          if (loc) {
            itemHtml += '<div class="ot-journey-location">';
            itemHtml += '<svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>';
            itemHtml += escapeHtml(loc);
            itemHtml += '</div>';
          }
          itemHtml += '</div></div>';
          section.insertAdjacentHTML('beforeend', itemHtml);
        }
      }
    }
  }

  function applyShippingCard(order, trackingInfo, wrapper) {
    if (!wrapper) wrapper = document.querySelector('.order-tracking-wrapper');
    if (!wrapper) return;

    var trackingNumber = trackingInfo && trackingInfo.number ? trackingInfo.number : '';
    var trackingUrl = trackingInfo && trackingInfo.url ? trackingInfo.url : '#';

    var trackingValues = wrapper.querySelectorAll('.ot-tracking-value');
    for (var i = 0; i < trackingValues.length; i++) {
      if (trackingUrl && trackingUrl !== '#') {
        trackingValues[i].innerHTML = '<a href="' + escapeHtml(trackingUrl) + '" target="_blank" rel="noopener">' + escapeHtml(trackingNumber) + '</a>';
      } else {
        trackingValues[i].textContent = trackingNumber;
      }
    }

    var trackLinks = wrapper.querySelectorAll('.ot-track-link');
    for (var j = 0; j < trackLinks.length; j++) {
      trackLinks[j].setAttribute('href', trackingUrl);
    }

    if (typeof window.copyTrackingNumber === 'undefined') {
      window.copyTrackingNumber = function () {
        var el = document.querySelector('.ot-tracking-value');
        var text = el ? (el.textContent || el.innerText || '').trim() : '';
        if (!text && el) {
          var a = el.querySelector('a');
          if (a) text = a.textContent || a.innerText || '';
        }
        if (text) {
          navigator.clipboard.writeText(text).then(function () {
            if (typeof alert !== 'undefined') alert('Tracking number copied to clipboard!');
          }, function (err) { console.error('Could not copy text: ', err); });
        }
      };
    }
  }

  function showSkeleton(wrapper) {
    if (wrapper) wrapper.classList.add('ot-loading');
  }

  function hideSkeleton(wrapper) {
    if (wrapper) wrapper.classList.remove('ot-loading');
  }

  function showError(wrapper, message) {
    if (!wrapper) return;
    wrapper.classList.remove('ot-loading');
    wrapper.classList.add('ot-loading-error-visible');
    var el = document.getElementById('ot-loading-error');
    if (el) el.textContent = message || 'Unable to load order details. Please check your email and try again.';
  }

  function run() {
    if (!isOrderDetailPage()) return;

    var params = getUrlParams();
    var email = params.email || params.Email || '';
    var orderNumberOrTracking = params.order_number || params.tracking_number || params['Order/Tracking Number'] || params['Order%2FTracking%20Number'] || '';

    if (!email) return;

    var wrapper = document.querySelector('.order-tracking-wrapper');
    if (!wrapper) return;

    showSkeleton(wrapper);

    var urls = getApiUrls(wrapper);

    fetchOrders(email, urls.shopify)
      .then(function (ordersData) {
        var order = selectOrder(ordersData, orderNumberOrTracking);
        if (!order) {
          showError(wrapper, 'No order found for this email. Please check and try again.');
          return;
        }

        var trackingInfo = getFirstTrackingInfo(order);
        var trackingNumber = trackingInfo && trackingInfo.number ? trackingInfo.number : '';

        return fetchFedExTracking(trackingNumber, urls.fedex).then(function (fedexData) {
          var stepIndex = getProgressStepFromFedEx(fedexData);
          var progressDates = getProgressDatesFromFedEx(fedexData, order.createdAt);

          hideSkeleton(wrapper);
          applyOrderInfo(order, fedexData, trackingInfo);
          applyProgressSteps(stepIndex, wrapper, progressDates);
          applyLineItems(order, wrapper);
          applyBilling(order, wrapper);

          var scanEvents = getScanEvents(fedexData);
          applyJourney(scanEvents, wrapper);

          applyShippingCard(order, trackingInfo, wrapper);
        });
      })
      .catch(function (err) {
        console.error('Order details dynamic error:', err);
        var msg = 'Could not load order details. Please check your connection and try again.';
        var errStr = (err && (err.message || err.toString)) ? (err.message || err.toString()) : '';
        if (errStr.indexOf('fetch') !== -1 || (err && err.name === 'TypeError')) {
          msg = 'Order service could not be reached. If you manage this site, set the "Shopify GraphQL API URL" in the Order Tracking section to your backend.';
        } else if (errStr.indexOf('Orders request failed') !== -1) {
          msg = errStr;
        } else if (errStr && errStr.length < 200) {
          msg = errStr;
        }
        showError(wrapper, msg);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
